
import ConfigScene from '../helpers/ConfigScene';

class InfoBubble extends PIXI.Container {
  constructor() {
    super();

    // const
    this.LIMIT_X = 190;
    this.LIMIT_Y_TOP = 180;
    this.LIMIT_Y_BTM = 210;

    // vars
    this.isVisible = false;
    this.isOpen = false;
    this.tempHitData = {
      hR: 250,
    };

    // app
    this.isApp = false;
    this.appLink = '';

    // centering
    this.tempDiff = 0;
    this.tempDateH = 0;
    this.tempBtnH = 0;
    this.tempPad = 0;

    this.startStyles = [
      { font: `20px ${ConfigScene.FONT_BASE}`, fill: '#407c85' },
      { font: `20px ${ConfigScene.FONT_BASE}`, fill: '#134d54' },
      { font: `15px ${ConfigScene.FONT_BASE}`, fill: '#ffffff' },
    ];

    this.actualId = -1; // actual open id
    this.infoData = null; // actual info data
    this.acData = null; // temp activity data data

    // parts
    this.closeBg = null;
    this.mainBg = null;

    this.titleDate = null;
    this.titleTx1 = null;
    this.titleTx2 = null;

    this.startBtnTx = null;
    this.startBtn = null;
    this.startBtnBg = null;
    this.startBtnFld = null;

    this.closeBtnTx = null;
    this.closeBtn = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    // props
    this.visible = false;

    // parts
    this.setParts();

    // lsns
    aScene.signals.infoCall.add(this.infoCallFc, this);
  }

  // --------------------------------------------------------------
  // OverCheck
  // --------------------------------------------------------------

  // to prevent hover state on items under bubble

  overCheck() {
    if (aPage.features.isTouch) {
      return this.isVisible; // prevent double item select on touch
    }
    return this.isVisible && aScene.collisionHelper.hitCircle(this.position, this.tempHitData, false);
  }

  // --------------------------------------------------------------
  // Set parts
  // --------------------------------------------------------------

  setParts() {
    this.closeBg = new PIXI.Container();
    this.addChild(this.closeBg);
    this.closeBg.interactive = true;
    this.closeBg.on('pointerup', () => {
      aScene.signals.infoCall.dispatch(ConfigScene.E_INFO_BLL_HIDE);
    });

    this.setMainBg();

    // titles
    this.setTitleDate();
    this.setTitleTx1();
    this.setTitleTx2();

    // buttons
    this.setCloseBtn();
    this.setStartBtn();
  }

  setMainBg() {
    this.mainBg = new PIXI.Sprite.fromFrame('win-info-bg.png');
    this.addChild(this.mainBg);
    this.mainBg.anchor.x = 0.5;
    this.mainBg.anchor.y = 0.5;
    this.mainBg.interactive = true; // to prevent clicking on items underneath
  }

  resetCloseBg() {
    this.closeBg.hitArea = new PIXI.Rectangle(
      -this.x,
      -this.y,
      aPage.resizer.canvasW, aPage.resizer.canvasH);
  }

  // --------------------------------------------------------------
  // Title - date
  // --------------------------------------------------------------

  setTitleDate() {
    this.titleDate = new PIXI.Text('', {
      font: `18px ${ConfigScene.FONT_BASE}`,
      fill: '#ffffff',
    });
    this.titleDate.y = -90;
    this.addChild(this.titleDate);
  }

  updateTitleDate(dateNum) {
    this.titleDate.text = `${dateNum}. prosince`;
    this.titleDate.updateText();
    this.titleDate.x = -Math.round(this.titleDate.width * 0.5);
  }

  // --------------------------------------------------------------
  // Title - Tx 1
  // --------------------------------------------------------------

  setTitleTx1() {
    this.titleTx1 = new PIXI.Text('', {
      font: `28px ${ConfigScene.FONT_BASE}`,
      fill: '#ffffff',
      align: 'center',
      wordWrap: true,
      wordWrapWidth: 220,
    });
    this.addChild(this.titleTx1);
  }

  updateTitleTx1(txt) {
    this.titleTx1.text = txt;
    this.titleTx1.updateText();
    this.titleTx1.x = -Math.round(this.titleTx1.width * 0.5);
  }

  // --------------------------------------------------------------
  // Title - Tx 2
  // --------------------------------------------------------------

  setTitleTx2() {
    this.titleTx2 = new PIXI.Text('', {
      font: `18px ${ConfigScene.FONT_BASE}`,
      fill: '#ffffff',
      align: 'center',
      wordWrap: true,
      wordWrapWidth: 200,
    });
    this.addChild(this.titleTx2);
  }

  updateTitleTx2(txt) {
    this.titleTx2.text = txt;
    this.titleTx2.updateText();
    this.titleTx2.x = -Math.round(this.titleTx2.width * 0.5);
  }

  // --------------------------------------------------------------
  // Start btn
  // --------------------------------------------------------------

  setStartBtn() {
    // container
    this.startBtn = new PIXI.Container();
    this.addChild(this.startBtn);

    // bg
    this.startBtnTx = [
      PIXI.Texture.fromImage('win-info-btn-play-normal.png'),
      PIXI.Texture.fromImage('win-info-btn-play-hover.png'),
      PIXI.Texture.fromImage('win-info-btn-locked.png'),
    ];

    this.startBtnBg = new PIXI.Sprite(this.startBtnTx[0]);
    this.startBtnBg.anchor.x = 0.5;
    this.startBtnBg.anchor.y = 0.5;
    this.startBtn.addChild(this.startBtnBg);

    // tx
    this.startBtnFld = new PIXI.Text('', this.startStyles[0]);
    this.startBtn.addChild(this.startBtnFld);

    // events
    this.startBtn.interactive = true;
    this.startBtn.buttonMode = true;
    this.startBtn.on('pointerup', () => {
      this.startActivity();
      aScene.signals.infoCall.dispatch(ConfigScene.E_INFO_BLL_HIDE);
    });
    this.startBtn.on('pointerover', () => {
      this.startBtnFld.style = this.startStyles[1];
      this.startBtnBg.texture = this.startBtnTx[1];
    });
    this.startBtn.on('pointerout', () => {
      this.startBtnFld.style = this.startStyles[0];
      this.startBtnBg.texture = this.startBtnTx[0];
    });
  }

  updateStartBtn(title) {
    this.checkStoreLinks();
    if (this.isApp) {
      this.startBtnFld.visible = false;
      this.startBtn.alpha = (this.appLink.length > 0) ? 1 : 0.3;
    } else {
      this.startBtnFld.visible = true;
      this.startBtn.alpha = 1;
    }
    this.startBtn.interactive = this.isOpen;
    this.startBtn.buttonMode = this.isOpen;
    if (this.isOpen) {
      this.startBtn.y = 70;
      this.startBtnBg.texture = this.startBtnTx[0];
      this.startBtnFld.style = this.startStyles[0];
      this.startBtnFld.text = title;
    } else {
      this.startBtn.y = 62;
      this.startBtnBg.texture = this.startBtnTx[2];
      this.startBtnFld.style = this.startStyles[2];
      this.startBtnFld.text = this.getUnlockString();
    }
    // center text
    this.startBtnFld.updateText();
    this.startBtnFld.x = -Math.round(this.startBtnFld.width * 0.5);
    this.startBtnFld.y = -Math.round(this.startBtnFld.height * 0.5);
  }

  startActivity() {
    if (this.isApp) {
      if (this.appLink.length > 0) {
        window.open(this.appLink, '_blank');
      }
    } else if (aPage.features.isAppOpen(aScene.daysInfoArr[this.actualId])) {
      window.location.hash = aScene.daysInfoArr[this.actualId].linkHash;
    } else {
      window.location.hash = aScene.daysInfoArr[this.actualId].alt.linkHash;
    }
  }

  checkStoreLinks() {
    if (aPage.features.isMobile && this.infoData.appLinks) {
      this.isApp = true;
      if (aPage.features.isIOS) {
        this.appLink = this.infoData.appLinks.ios;
        this.startBtnTx = [
          PIXI.Texture.fromImage('win-info-store-ios.png'),
          PIXI.Texture.fromImage('win-info-store-ios.png'),
          PIXI.Texture.fromImage('win-info-btn-locked.png'),
        ];
      } else {
        this.appLink = this.infoData.appLinks.play;
        this.startBtnTx = [
          PIXI.Texture.fromImage('win-info-store-android.png'),
          PIXI.Texture.fromImage('win-info-store-android.png'),
          PIXI.Texture.fromImage('win-info-btn-locked.png'),
        ];
      }
    } else if (this.isApp) {
      // reset back
      this.isApp = false;
      this.startBtnTx = [
        PIXI.Texture.fromImage('win-info-btn-play-normal.png'),
        PIXI.Texture.fromImage('win-info-btn-play-hover.png'),
        PIXI.Texture.fromImage('win-info-btn-locked.png'),
      ];
    }
  }

  getUnlockString() {
    const dateDiff = (1 + this.actualId) - actionUuids.length;
    let dayLabel = '';
    if (dateDiff === 1) {
      dayLabel = 'den';
    } else if (dateDiff < 5) {
      dayLabel = 'dny';
    } else {
      dayLabel = 'dní';
    }
    return `Odemkne se za ${dateDiff} ${dayLabel}`;
  }

  // --------------------------------------------------------------
  // Set btn close
  // --------------------------------------------------------------

  setCloseBtn() {
    this.closeBtnTx = [
      PIXI.Texture.fromImage('win-info-btn-close-normal.png'),
      PIXI.Texture.fromImage('win-info-btn-close-hover.png'),
    ];

    this.closeBtn = new PIXI.Sprite(this.closeBtnTx[0]);
    this.closeBtn.x = 69;
    this.closeBtn.y = -113;
    this.addChild(this.closeBtn);

    this.closeBtn.interactive = true;
    this.closeBtn.buttonMode = true;
    this.closeBtn.on('pointerup', () => {
      aScene.signals.infoCall.dispatch(ConfigScene.E_INFO_BLL_HIDE);
    });
    this.closeBtn.on('pointerover', () => {
      this.closeBtn.texture = this.closeBtnTx[1];
    });
    this.closeBtn.on('pointerout', () => {
      this.closeBtn.texture = this.closeBtnTx[0];
    });
  }

  // --------------------------------------------------------------
  // Lsn
  // --------------------------------------------------------------

  infoCallFc(sgType, optParams) {
    switch (sgType) {
      case ConfigScene.E_INFO_BLL_SHOW:
        if (this.actualId !== optParams[0]) {
          // update id
          this.actualId = optParams[0];
          // set position
          this.setPosition(optParams[1]);
          // update
          this.updateContent();
          // show
          this.showBll(true);
          // stats
          aPage.stats.trackEvent('Open-Info', this.actualId);
        }
        break;
      case ConfigScene.E_INFO_BLL_HIDE:
        if (this.actualId !== -1) {
          this.actualId = -1;
          this.showBll(false);
        }
        break;
      default:
    }
  }

  setPosition(posPoint) {
    this.x = posPoint.x;
    this.y = posPoint.y;

    // limits
    if (this.x < this.LIMIT_X) {
      this.x = this.LIMIT_X;
    } else if (this.x > aPage.resizer.canvasW - this.LIMIT_X) {
      this.x = aPage.resizer.canvasW - this.LIMIT_X;
    }

    if (this.y < this.LIMIT_Y_TOP) {
      this.y = this.LIMIT_Y_TOP;
    } else if (this.y > aPage.resizer.canvasH - this.LIMIT_Y_BTM) {
      this.y = aPage.resizer.canvasH - this.LIMIT_Y_BTM;
    }

    // round
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
  }

  // --------------------------------------------------------------
  // Show/Hide
  // --------------------------------------------------------------

  showBll(doShow) {
    TweenMax.killTweensOf(this);
    TweenMax.killTweensOf(this.scale);
    if (doShow) {
      this.isVisible = true;
      // show
      this.resetCloseBg();
      this.visible = true;
      this.alpha = 0.0;
      this.scale.x = 0.5;
      this.scale.y = 0.5;
      TweenMax.to(this, 0.4, { alpha: 1.0, ease: Sine.easeOut });
      TweenMax.to(this.scale, 0.4, { x: 1.0, y: 1.0, ease: Back.easeOut });
    } else {
      this.isVisible = false;
      // hide
      TweenMax.to(this, 0.3, { alpha: 0.0, onComplete: this.hideComplete, onCompleteScope: this });
      TweenMax.to(this.scale, 0.3, { x: 0.4, y: 0.4, ease: Sine.easeIn });
    }
  }

  hideComplete() {
    this.visible = false;
  }

  updateContent() {
    this.infoData = aScene.daysInfoArr[this.actualId];
    if (!aPage.features.isAppOpen(this.infoData)) {
      this.infoData = this.infoData.alt;
    }

    this.isOpen = this.actualId < actionUuids.length;

    this.updateTitleDate(this.actualId + 1);
    this.updateTitleTx1(this.infoData.title1);
    this.updateTitleTx2(this.infoData.title2);
    this.updateStartBtn(this.infoData.sLabel);

    // set positions
    this.tempDateH = this.titleDate.height / 2;
    this.tempBtnH = this.startBtn.height / 2;
    this.tempDiff = this.startBtn.y - this.titleDate.y - this.tempDateH - this.tempBtnH;

    if (this.titleTx2.text.length < 2) {
      this.titleTx1.y = Math.round(
        (this.titleDate.y + this.tempDateH + (this.tempDiff * 0.5)) -
        (this.titleTx1.height * 0.5));
    } else {
      this.tempPad = (this.tempDiff - this.titleTx1.height - this.titleTx2.height) / 5;
      this.titleTx1.y = Math.round(this.titleDate.y + this.tempDateH + (this.tempPad * 2));
      this.titleTx2.y = Math.round(this.titleTx1.y + this.titleTx1.height + this.tempPad);
    }
  }
}

export default InfoBubble;



// WEBPACK FOOTER //
// ./src/js/scene/parts/InfoBubble.js